"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchDataNextPage = exports.isNearBottom = exports.handleScrollLoadMore = void 0;
const handleScrollLoadMore = (loading, currentData, fetchData) => {
    if (currentData.pagination &&
        currentData.pagination.currentPage < currentData.pagination.totalPages &&
        !loading) {
        fetchData(currentData.pagination.currentPage + 1, currentData.pagination.pageSize, true);
    }
};
exports.handleScrollLoadMore = handleScrollLoadMore;
const isNearBottom = (element) => {
    if (!element)
        return false;
    const { scrollTop, scrollHeight, clientHeight } = element;
    return scrollHeight - (scrollTop + clientHeight) < 200;
};
exports.isNearBottom = isNearBottom;
const fetchDataNextPage = (pagination, fetchData) => {
    if (pagination.currentPage < pagination.totalPages) {
        fetchData(pagination.currentPage + 1, pagination.pageSize, true);
    }
};
exports.fetchDataNextPage = fetchDataNextPage;
